import { render, staticRenderFns } from "./ModalNotificationInput.vue?vue&type=template&id=acd07106&scoped=true&"
import script from "./ModalNotificationInput.vue?vue&type=script&lang=js&"
export * from "./ModalNotificationInput.vue?vue&type=script&lang=js&"
import style0 from "./ModalNotificationInput.vue?vue&type=style&index=0&id=acd07106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd07106",
  null
  
)

export default component.exports